import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    Background,
    ReactFlow,
    useNodesState,
    useEdgesState,
    addEdge,
    useReactFlow,
    ReactFlowProvider,
    MarkerType,
} from '@xyflow/react';
import CreatableSelect from "react-select/creatable"
import '@xyflow/react/dist/style.css';
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData";
import secureLocalStorage from 'react-secure-storage';
import Loader from '../Loader';
import AnnotationNode from './AnnotationNode';
import { ResizableBox } from 'react-resizable';
import Draggable from "react-draggable"
import { Row } from 'reactstrap';
import Swal from 'sweetalert2';

const initialNodes = [
    {
        id: '0',
        type: 'customNode',
        data: {
            label: 'Node 1',
            htmlContent: '<span><em>Select staff from the list </em></span>',
            show: false
        },  // Initial label
        position: { x: 0, y: 50 },
    },
];

let id = 1;
const getId = () => `${id++}`;
const nodeOrigin = [0.5, 0];

const AddNodeOnEdgeDrop = () => {
    document.title = "Company Structure";
    const reactFlowWrapper = useRef(null);

    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [allDatas, setAllDatas] = useState([])
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const [isLoading, setLoading] = useState(false)
    const { screenToFlowPosition, zoomTo } = useReactFlow();
    const [nodeLabels, setNodeLabels] = useState({}); // To keep track of labels
    const [staffOption, setStaffOption] = useState([])
    const [staffDescription, setStaffDescription] = useState(false)
    const [sideBar, setsideBar] = useState(true)
    const [description, setDescription] = useState('')
    const [nodeId, setNodeId] = useState('')
    const token = secureLocalStorage.getItem('auth_token')
    const onConnect = useCallback(
        (params) => setEdges((eds) => addEdge(params, eds)),
        [],
    );

    useEffect(() => {
        const getHirechy = async () => {
            const res = await fetchNodeData(setLoading, 'company_hierarchy', token);
            if (res?.success) {
                console.log(res?.data)
                if (res?.data != null) {
                    const NodesData = res?.data?.node ? JSON.parse(res?.data?.node) || [] : []
                    const EdgesData = res?.data?.edges ? JSON.parse(res?.data?.edges) || [] : []
                    setEdges(EdgesData)
                    setNodes(NodesData)
                } else {
                    setNodes(initialNodes)
                }

            }
        }
        getHirechy()
    }, [])

    const onConnectEnd = useCallback(
        (event, connectionState) => {
            // when a connection is dropped on the pane it's not valid

            if (!connectionState.isValid) {
                const newId = (() => {
                    if (edges.length === 0) return 1;

                    // Extract numeric IDs and find max
                    const ids = edges.map(edge => {
                        const num = parseInt(edge.id, 10);
                        return isNaN(num) ? 0 : num;
                    });
                    return Math.max(...ids) + 1;
                })();
                const { clientX, clientY } =
                    'changedTouches' in event ? event.changedTouches[0] : event;
                const newNode = {
                    id: newId.toString(),
                    type: 'customNode',
                    position: screenToFlowPosition({
                        x: clientX,
                        y: clientY,
                    }),
                    data: {
                        label: `Node ${newId.toString()}`,
                        htmlContent: '<span><em>Select staff from the list </em></span>',
                        show: false
                    },
                    origin: [0.5, 0.0],
                };

                setNodes((nds) => nds.concat(newNode));
                setEdges((eds) =>
                    eds.concat({
                        id: newId.toString(),
                        source: connectionState.fromNode.id,
                        target: newId.toString(),
                        markerEnd: {
                            type: MarkerType.ArrowClosed,
                        },
                    }),
                );
            }
        },
        [screenToFlowPosition, edges],
    );

    const onLabelChange = (selected, nodeId) => {
        const exists = nodes?.some((node) => node?.data?.value?.value == selected?.value);
        console.log(nodes?.some((node) => node?.data?.value?.value == selected?.value), selected?.value)

        // Define the node update logic once
        const updateNode = () => {
            setNodes((nds) =>
                nds.map((node) =>
                    node.id === nodeId
                        ? {
                            ...node,
                            data: {
                                ...node.data,
                                label: selected?.name || node.data.label,
                                htmlContent: `<div><b>${selected?.name || 'Unassigned'}</b><br/><small>${selected?.email || ''}</small></div>`,
                                allData: selected,
                                show: true,
                                value: selected,
                            },
                        }
                        : node
                )
            );
        };

        if (exists) {
            Swal.fire({
                icon: 'warning',
                title: 'Staff Already Exists in hierarchy!',
                text: 'Are you sure you still want to add this staff?',
                showCancelButton: true,
                confirmButtonColor: '#762C99',
                confirmButtonText: 'Yes, Add it!',
            }).then((result) => {
                if (result?.isConfirmed) {
                    updateNode();
                }
            });
        } else {
            updateNode();
        }
    };


    // Handle edge removal
    const onEdgeClick = useCallback(
        (event, edge) => {
            setEdges((eds) => eds.filter((e) => e.id !== edge.id));
        },
        [],
    );

    const colourStyles = {
        control: (styles) => ({
            ...styles,
            minHeight: '35px',   // reduce height here
            height: '35px',
        }),
        valueContainer: (styles) => ({
            ...styles,
            height: '35px',
            padding: '0 6px',
        }),
        indicatorsContainer: (styles) => ({
            ...styles,
            height: '35px',
        }),
    }
    useEffect(() => {
        const fetchStaff = async () => {
            const datas = await fetchNodeData(setLoading, "staff", secureLocalStorage.getItem("auth_token"));
            setStaffOption(datas?.data?.map((obj) => ({
                value: obj?.id,
                label: obj?.name,
                ...obj
            })))
        }
        fetchStaff()
    }, [])
    const nodeTypes = {
        customNode: AnnotationNode,
    };

    const onAddDescription = async (e) => {
        e.preventDefault();
        const item = nodes.find(obj => obj.id == nodeId);
        if (item) {
            item.description = description;
        }
        const formEntries = {
            node: JSON.stringify(nodes) || '',
            edges: JSON.stringify(edges) || ''
        }
        const res = await FetchNodePostData(setLoading, 'company_hierarchy', token, formEntries);
        if (res?.data?.success) {
            Swal.fire({
                icon: "success",
                text: "Staff Description has been Saved"
            })
            setNodes(nodes)
            setStaffDescription(false)
        }
    }


    const onSaveNodes = () => {
        Swal.fire({
            title: "Are you sure?",
            text: `Do you want to Save this Hirechy`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#762C99",
            confirmButtonText: "Yes, Save it!",
        }).then(async (isOkay) => {
            if (isOkay?.isConfirmed) {
                const formEntries = {
                    node: JSON.stringify(nodes) || '',
                    edges: JSON.stringify(edges) || ''
                }
                const res = await FetchNodePostData(setLoading, 'company_hierarchy', token, formEntries);
                if (res?.data?.success) {
                    Swal.fire({
                        icon: "success",
                        text: "Hirechy has been Saved and Displayed on website"
                    })
                }
            }
        })
    }

    return (
        <div className="wrapper position-relative" ref={reactFlowWrapper}>
            {isLoading && <Loader />}
            <ReactFlow
                style={{ backgroundColor: '#F7F9FB' }}
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                onConnectEnd={onConnectEnd}
                onEdgeClick={onEdgeClick}
                fitView
                defaultZoom={0.8}
                onInit={(instance) => {
                    instance.zoomTo(0.8); // 👈 Zoom in once React Flow is ready
                }}
                fitViewOptions={{ padding: 0 }}
                nodeOrigin={nodeOrigin}
                nodeTypes={nodeTypes}
            >
                <Background />
            </ReactFlow>
            {sideBar ? (
                <div className='d-flex flex-column gap-2 px-3 py-3 sideBarBox-hierecy'>
                    <div className='d-flex justify-content-between'>
                        <p className="text-purple fs-5 mb-3 fw-bold ">Company Structure</p>
                        <a onClick={() => setsideBar(false)}>
                            <i className="mdi mdi-chevron-left text-primary fs-4"></i>
                        </a>
                    </div>
                    <div className='height-fix'>
                        <label className='mb-2'>Select Staff </label>

                        {nodes.map((node) => {
                            return (
                                <div key={node.id} className='d-flex justify-content-between align-items-center mb-3'>
                                    <CreatableSelect
                                        isClearable
                                        name="project"
                                        placeholder={`Select`}
                                        className="basic-multi-select  col-md-10"
                                        classNamePrefix=" select"
                                        styles={colourStyles}
                                        options={staffOption}
                                        value={node?.data?.value || []}
                                        onChange={(e) => onLabelChange(e, node.id)}
                                    />
                                    <a className="btn btn-sm btn-outline-primary me-1" title="Add Description"
                                        onClick={() => {
                                            setNodeId(node.id)
                                            setDescription(node?.description || '')
                                            setStaffDescription(true)
                                        }}
                                    >
                                        <i className="fa fa-info"></i>
                                    </a>
                                </div>
                            )
                        }
                        )}
                    </div>
                </div>
            ) : (
                <div className="floating-btn sidebar-box" onClick={() => setsideBar(true)}>
                    <button className="bd-report-float btn btn-purple">sideBar</button>
                </div>
            )}

            <div
                className={`note-sticky-form ${staffDescription ? "d-block" : "d-none"
                    }`}
            >
                <Draggable
                    handle={".head-move"}
                    cancel={".modal-body"}
                >
                    <ResizableBox
                        width={800}
                        style={{
                            position: "fixed",
                            top: "21%",
                            left: "19%",
                            zIndex: "1055",
                            backgroundColor: "rgb(255, 255, 255)",
                        }}
                    >
                        <div>
                            <form onSubmit={onAddDescription}>
                                <Row className="align-items-center">
                                    <div className="col-12 d-flex justify-content-between head-move " >
                                        <h5>Staff Description</h5>
                                        <div className="text-end">
                                            <button className="btn btn-purple  me-2 btn-lable">
                                                <i className="fas fa-plus me-2 label-icon"></i>Add
                                                Description
                                            </button>
                                            <a
                                                onClick={() => setStaffDescription(false)}
                                                className="btn btn-red text-uppercase btn-lable"
                                            >
                                                <i className="dripicons-cross me-1 icon-center label-icon"></i>
                                                Close
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-12 ">
                                        <div className="col-md-12 mt-3">
                                            <label htmlFor="">Description</label>
                                            <textarea
                                                type="number"
                                                placeholder="Enter Description"
                                                className="form-control "
                                                rows={5}
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Row>
                            </form>
                        </div>
                    </ResizableBox>
                </Draggable>
            </div>

            <div>
                <a className=" btn text-white text-uppercase me-0 btn-save btn-label border-radius save-btn hirechy-save" onClick={() => onSaveNodes()}>
                    <i className="fas fa-save  label-icon"></i>
                    Save Hirechy
                </a>
            </div>

        </div>
    );
};

const Hirechynew = () => (
    <ReactFlowProvider>
        <AddNodeOnEdgeDrop />
    </ReactFlowProvider>
);

export default Hirechynew;
